<template>
	<div class="scatch_container">
		<div class="scatch" ref="scatch">
			<ScratchCard :key="renderCount"
					:cardWidth="cardWidth"
					:cardHeight="cardHeight"
					:finishPercent="finishPercent"
					:imageUrl="imageUrl"
					:forceReveal="forceReveal">
			<h2 class="card-content">{{text}}</h2>
			</ScratchCard>
		</div>
		<div class="div_center">
			<button @click="result" class="btn btn_primary" type="submit">{{$t("txt_findOut")}}</button>
		</div>
	</div>
</template>

<script>
import ScratchCard from 'vue-scratchcard';
import { mapGetters } from 'vuex'
export default {
  	name: 'Scratch',
  	components: {
    	ScratchCard,
  	},
  	data() {
		return {
			renderCount: 0,
			finishPercent: 90,
			forceReveal: false,
		};
  	},
	props: {
		cardWidth: {
			type: Number,
			default: 300
		},
		cardHeight: {
			type: Number,
			default: 300
		},
		text: {
			type: String,
			required: true
		},
		imageUrl: {
			type: String,
			required: true
		}
	},
  	computed: {
        ...mapGetters(["getUserInfo"]),
    },
	methods: {
		result(){
			this.$emit("onResult")
		}
	}
};
</script>